export default __webpack_public_path__ + "static/media/grip.a43661fe.png";